import React from 'react';
import { node, string, func, bool } from 'prop-types';

import styles from './CollapseItem.scss';

const cx = require('classnames/bind').bind(styles);

function CollapseItem({ title, icon, descr, isSelected, onClick }) {
  return (
    <div onClick={onClick} className={cx(styles.root, { isSelected })}>
      {isSelected && <img src={icon} className={styles.icon} />}
      <h4>{title}</h4>
      <p className={styles.descr}>{descr}</p>
    </div>
  );
}

CollapseItem.propTypes = {
  descr: string.isRequired,
  icon: node.isRequired,
  isSelected: bool.isRequired,
  title: string.isRequired,
  onClick: func.isRequired,
};

export default CollapseItem;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/ProductFeatures/components/CollapseItem/CollapseItem.jsx